// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ColorRectangle_wrapper__3r1Xy","wrapper__blue":"ColorRectangle_wrapper__blue__JfVGh","wrapper__green":"ColorRectangle_wrapper__green__1J_td"};